/**
 * Global Alert Override
 * Replaces browser's alert() and confirm() with custom themed versions
 * This allows gradual migration - new code uses useGlobalAlert hook,
 * old code automatically uses themed alerts via window override
 */

let alertQueue = [];
let showAlertFunction = null;
let showConfirmFunction = null;

export const setGlobalAlertFunctions = (showAlert, showConfirm) => {
  showAlertFunction = showAlert;
  showConfirmFunction = showConfirm;
  
  // Override window.alert
  if (typeof window !== 'undefined') {
    window.alert = function(message) {
      if (showAlertFunction) {
        showAlertFunction(String(message), 'Alert', 'info');
      } else {
        // Fallback to original if not yet initialized
        window._originalAlert(message);
      }
    };
    
    // Override window.confirm
    window.confirm = function(message) {
      if (showConfirmFunction) {
        // Return a Promise that resolves to boolean
        // Note: This makes confirm async, which is technically breaking
        // but necessary for custom modals
        return showConfirmFunction(String(message), 'Confirm')
          .then(result => result)
          .catch(() => false);
      } else {
        // Fallback to original if not yet initialized
        return window._originalConfirm(message);
      }
    };
  }
};

export const restoreOriginalAlerts = () => {
  if (typeof window !== 'undefined' && window._originalAlert) {
    window.alert = window._originalAlert;
    window.confirm = window._originalConfirm;
  }
};
